<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/responsaveis">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Email" v-model="dataset.data.email" required
                                                :rules="[$rules.required, $rules.email]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>


                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="CPF" v-model="dataset.data.registration" required
                                                :rules="[$rules.required, $rules.cpf]" v-mask="$masks.cpf" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Telefone" v-model="dataset.data.phone_number"
                                                v-mask="$masks.phone" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>

                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input dense accept="image/png, image/jpeg, application/pdf"
                                                prepend-icon="" outlined counter :rules="[$rules.fileSize(2)]"
                                                hint="O arquivo não pode ser superior a 2MB" hide-details="auto"
                                                label="Imagem" :clearable="true" @change="onFileSelected($event)"
                                                ref="file">
                                            </v-file-input>

                                            <v-img v-if="dataset.data.document_url"
                                                @click="openDoc(dataset.data.document_url)" class="rounded-xl"
                                                :height="100" :width="100" :src="dataset.data.document_url">
                                            </v-img>

                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-card class="card-form-outlined">
                        <v-row align="center">
                            <v-col>
                                <v-card-title class="card-group-title">Endereço</v-card-title>
                            </v-col>
                        </v-row>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-text-field dense label="CEP" v-model="dataset.data.address_postal_code" required
                                        :rules="[$rules.required]" v-mask="$masks.zipCode" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" @click="loadZipcodeData()">Buscar</v-btn>
                                        </template>
                                        <span>Buscar endereço</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="10">
                                    <v-text-field dense label="Rua" v-model="dataset.data.address_street" required
                                        :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-text-field dense label="Número" v-model="dataset.data.address_number" outlined
                                        hide-details="auto">
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Bairro" v-model="dataset.data.address_district" required
                                        :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field disabled readonly dense label="Cidade"
                                        v-model="dataset.data.address_city" required :rules="[$rules.required]" outlined
                                        hide-details="auto">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="2">
                                    <v-select disabled readonly no-data-text="Nenhuma UF encontrada" dense
                                        :items="dataset.states" label="UF" v-model="dataset.data.address_state"
                                        item-value="acronym" item-text="acronym" outlined :rules="[$rules.required]"
                                        required hide-details="auto">
                                    </v-select>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-form>


        <v-row>
            <v-col>
                <v-card class="card-form-outlined">

                    <v-row align="center">
                        <v-col>
                            <v-card-title class="card-group-title">{{ studentTitle }}</v-card-title>
                        </v-col>
                    </v-row>

                    <v-card-text>
                        <student-autocomplete
                            multiple
                            label="Alunos vinculados"
                            :value="dataset.students.map(student => student.id)"
                            :selected-items="dataset.students"
                            @input="syncSelectedStudentIds"
                            @selected="setSelectedStudents"
                        />
                    </v-card-text>

                    <v-card-text v-if="dataset.students && dataset.students.length > 0">
                        <v-row>
                            <v-col cols="6" v-for="(item, index) in dataset.students" :key="index">
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-img v-if="item.document_url" :src="item.document_url"></v-img>
                                        <v-icon v-else size="32">mdi-account-school-outline</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-subtitle> {{ item.name }}</v-list-item-subtitle>
                                        <!-- <v-list-item-subtitle>Turma: {{ item.class.name }}</v-list-item-subtitle> -->
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="removeStudent(item)"
                                                    size="large">mdi-delete-outline</v-icon>
                                            </template>
                                            <span>Remover aluno</span>
                                        </v-tooltip>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-col>

                        </v-row>

                    </v-card-text>

                    <v-card-text v-else>
                        <span>Nenhum aluno associado</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogViewDoc" max-width="60%">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import string from "@/common/util/string"
import axios from "axios"
import states from "@/common/data/states.data"
import { eventHub } from "@/main";
import StudentAutocomplete from "@/layouts/components/StudentAutocomplete.vue"

export default {
    name: "AnswerableDetails",
    components: {
        StudentAutocomplete,
    },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            data: {
                // students: []
            },
            students: [],

            states: states,
            modalResult: null,
        },
        selectedDoc: null,
        dialogViewDoc: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

    }),

    created() {
        this.loadData();

        eventHub.$on('DIALOG-STUDENT-SELECTION', value => {
            this.dialogStudentSelection = value;
        });
    },

    computed: {
        studentTitle() {
            if (!this.dataset.data || !this.dataset.data.students || this.dataset.data.students.length === 1) {
                return "Aluno";
            } else {
                return "Alunos";
            }
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/responsaveis");
        },

        openDoc(cover) {
            this.selectedDoc = cover;
            this.dialogViewDoc = true;
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Novo responsável' : 'Detalhes do responsável'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Responsaveis",
                disabled: false,
                to: "/responsaveis",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        syncSelectedStudentIds(studentIds) {
            const selectedIds = (studentIds || []).map((id) => Number(id));
            this.dataset.students = this.dataset.students.filter((student) => selectedIds.includes(Number(student.id)));
        },

        setSelectedStudents(students) {
            this.dataset.students = students || [];
        },


        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/answerables/${this.$route.params.id}`);

                console.log('result ', result)

                const data = result.data.content;

                this.dataset.data = data;

                this.dataset.students = data.students

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o responsavel?',
                title: 'Incluir responsavel',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v1/answerables', payload);

                this.$dialog.notify.info("Responsável salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do responsável?',
                title: 'Atualizar responsável',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/answerables/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Responsavel salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.updateLoading = false;
            }
        },

        async removeStudent(item) {

            if (!item || !item.id) return;

            this.dataset.students = this.dataset.students.filter((student) => Number(student.id) !== Number(item.id));
        },

        onFileSelected(file) {
            this.dataset.data.file = file;
        },


        // buildPayload() {
        //     const data = {
        //         name: this.dataset.data.name,
        //         email: this.dataset.data.email,
        //         registration: string.sanitizeCpfCnpj(this.dataset.data.registration),
        //         phone_number: this.dataset.data.phone_number,
        //         address_street: this.dataset.data.address_street,
        //         address_number: this.dataset.data.address_number,
        //         address_district: this.dataset.data.address_district,
        //         address_postal_code: this.dataset.data.address_postal_code,
        //         address_state: this.dataset.data.address_state,
        //         address_city: this.dataset.data.address_city,
        //         students: this.dataset.students.map(student => student.id)

        //     }

        //     return data;

        // },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.email)
                formData.append('email', this.dataset.data.email);

            if (this.dataset.data.registration)
                formData.append('registration', string.sanitizeCpfCnpj(this.dataset.data.registration));

            if (this.dataset.data.phone_number)
                formData.append('phone', this.dataset.data.phone_number);

            if (this.dataset.data.vehicle_name)
                formData.append('vehicle_name', this.dataset.data.vehicle_name);

            if (this.dataset.data.vehicle_number)
                formData.append('vehicle_number', this.dataset.data.vehicle_number);

            if (this.dataset.data.vehicle_plate)
                formData.append('vehicle_plate', this.dataset.data.vehicle_plate);

            if (this.dataset.data.address_street)
                formData.append('address_street', this.dataset.data.address_street);

            if (this.dataset.data.address_number)
                formData.append('address_number', this.dataset.data.address_number);

            if (this.dataset.data.address_district)
                formData.append('address_district', this.dataset.data.address_district);

            if (this.dataset.data.address_postal_code)
                formData.append('address_postal_code', this.dataset.data.address_postal_code);

            if (this.dataset.data.address_state)
                formData.append('address_state', this.dataset.data.address_state);

            if (this.dataset.data.address_city)
                formData.append('address_city', this.dataset.data.address_city);

            if (this.dataset.data.file)
                formData.append('document', this.dataset.data.file)

            for (let index = 0; index < this.dataset.students.length; index++) {
                formData.append(`students[${index}]`, this.dataset.students[index].id)
            }

            return formData;
        },


        async loadZipcodeData() {

            if (!this.dataset.data.address_postal_code) {

                this.$dialog.notify.error("O campo CEP deve ser preenchido!", { position: "top-right", timeout: 3000 });

                return

            }

            const zipcode = string.sanitizeZipcode(this.dataset.data.address_postal_code)

            try {
                const result = await axios.get(`/api/v1/address/${zipcode}`);

                const resultData = result.data.content;

                const state = this.dataset.states.find((x) => x.acronym == resultData.state) || null

                console.log('state ', state, this.dataset.states)

                const data = {
                    address_street: resultData.street,
                    address_district: resultData.district,
                    address_state: state ? state.acronym : null,
                    address_city: resultData.city
                }

                this.dataset.data = { ...this.dataset.data, ...data }

            } catch (error) {
                console.log(error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
